import { VizContainerProps } from "./VizContainer";
import "../Viz.scss";
import { EntityImageDisplay } from "./Shared/EntityImageDisplay";
import { useView } from "../../../hooks/useView";
import { EntityVideoDisplay } from "./Shared/EntityVideoDisplay";

export type VizPreviewProps = VizContainerProps;

export function VizPreview(props: VizPreviewProps) {
    const { view } = useView(props.viewId);
    const selectedEntity = view?.selectedEntity;
    const showVideo =
        (selectedEntity?.images.videoPlaybackMode == "frames" && selectedEntity?.images.images.length > 1) ||
        selectedEntity?.images.videoPlaybackMode == "video";

    return (
        <div className="viz-preview viz-panel">
            <div className="viz-preview-title">{selectedEntity?.getTitle()}</div>
            {selectedEntity && !showVideo && (
                <div className="viz-preview-thumbnail position-relative">
                    <EntityImageDisplay
                        key={selectedEntity.id}
                        entityImage={selectedEntity.images.getMainImage()}
                        mediaId={selectedEntity.sourceObject.mediaSource?.mediaId}
                    />
                </div>
            )}
            {selectedEntity && showVideo && (
                <div>
                    <EntityVideoDisplay entity={selectedEntity} />
                </div>
            )}
            {!selectedEntity && (
                <div className="text-muted" style={{ marginBottom: "0.4rem" }}>
                    Select an item to view details
                </div>
            )}
        </div>
    );
}
